import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BuddibleSocket, { MsgIDList } from "../../../lib/BuddibleSocket";

const socket = new BuddibleSocket();
const _mClassName = "UserDetailModal";
export default function UserDetailModal(props) {
  const { checkSelectedUserChat } = props;
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    socket.addLocalEventListener(
      MsgIDList.EVENT_FAV_USER_DETAIL_MODAL_CALL,
      _mClassName,
      (b, n) => {
        setData(n);
      }
    );

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_FAV_USER_DETAIL_MODAL_CALL,
        _mClassName
      );
    };
  }, []);

  function closeModal() {
    setTimeout(() => {
      setData(null);
    }, 300);
  }

  function openNameCard(namecard) {
    window.open(namecard.split("?")[1], "_blank", "width=700, height=320");
  }

  return (
    <div
      className="modal fade"
      id="UserDetailModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-labelledby="UserDetailModal"
      data-backdrop="static"
      data-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header justify-content-end border-0">
            <i
              className="fas fa-plus fa-times cursor_pointer"
              data-dismiss="modal"
              aria-label="Close"
              id="UserDetailModalClose"
              onClick={closeModal}
            />
          </div>

          <div className="modal-body">
            {data !== null && (
              <>
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div
                    className="rounded-circle border mb-3"
                    style={{
                      minWidth: 120,
                      width: 120,
                      minHeight: 120,
                      background: `url(${data["USER_PIC"]}) 50% 50%/cover no-repeat`,
                    }}
                  />
                  <p className="font-size-08">{data["USER_PART_NM"]}</p>
                  <p className="font-weight-bold mb-3">
                    [{data["COMP_NM"]}] {data["USER_NICK"] || data["USER_NICK"]}
                  </p>
                  <div className="d-flex flex-row justify-content-around w-50">
                    {data["USER_NAME_CARD"] && (
                      <div
                        className="d-flex flex-column align-items-center cursor_pointer cursor_pointer_fw_bold"
                        onClick={() => openNameCard(data["USER_NAME_CARD"])}
                      >
                        <i className="fa-regular fa-address-card h6 mb-0"></i>
                        <p>{t("logiTalk.favList.profileModal.businessCard")}</p>
                      </div>
                    )}
                    <div
                      className="d-flex flex-column align-items-center cursor_pointer cursor_pointer_fw_bold"
                      onClick={() => {
                        checkSelectedUserChat(data.comp, data);
                        document.querySelector("#UserDetailModalClose").click();
                      }}
                    >
                      <i className="fa-regular fa-message h6 mb-0"></i>
                      <p>{t("logiTalk.favList.profileModal.talk")}</p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
